import React from "react";
import { Box, Typography } from "@mui/material";
import { Footer as FooterImages } from "../../assets/images/imageImports";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
    const location = useLocation();
    const isBgShow = (["/dashboard", "/", '/tools']).includes(location.pathname);

    return (
        <Box
            component="footer"
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                height: "32px",
                backgroundColor: isBgShow ? 'transparent' : 'white',
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                px: 3,
                zIndex: 1000,
            }}
            className="custom-footer"
        >
            <Typography variant="body2" sx={{ mr: 0.5, color: "text.secondary" }}>
                Powered by
            </Typography>
            <img
                src="/icons/WinWire.svg"
                alt="WinWire"
                style={{ height: "20px", width: "60px" }}
            />
        </Box>
    );
};

export default Footer;
